/**
 * « Comment ça marche » — une suite d'étapes numérotées.
 *
 * Le numéro est calculé au rendu, jamais saisi : renuméroter à la main
 * après avoir inséré une étape est le genre d'oubli qui se voit.
 */
const EtapesBloc = ({ bloc }) => {
    const etapes = Array.isArray(bloc?.etapes) ? bloc.etapes : [];
    if (etapes.length === 0) return null;

    return (
        <section className="mb-10" data-testid="bloc-etapes">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-5">{bloc.titre}</h2>
            )}
            <ol className="space-y-4">
                {etapes.map((e, i) => (
                    <li key={i} className="flex gap-4">
                        <span className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold text-white bg-gradient-to-br from-cabaza-purple to-cabaza-pink">
                            {i + 1}
                        </span>
                        <div className="pt-0.5">
                            {e.titre && (
                                <h3 className="font-semibold text-gray-900">{e.titre}</h3>
                            )}
                            {e.texte && (
                                <p className="text-sm text-gray-600 mt-0.5">{e.texte}</p>
                            )}
                        </div>
                    </li>
                ))}
            </ol>
        </section>
    );
};

export default EtapesBloc;
